class DisclosureInitializer {
  constructor() {
    this.disclosures = {};
  }
  update(id, value) {
    this.disclosures[id] = value;
    if (this.listener) {
      this.listener(this.disclosures);
    }
  }
  subscribe(listener) {
    this.listener = listener;
    this.listener(this.disclosures);
  }
  unsubscribe() {
    this.listener = void 0;
    this.disclosures = {};
  }
}
function initialize() {
  return new DisclosureInitializer();
}
const disclosureInitializer = initialize();
export {
  disclosureInitializer as d
};
//# sourceMappingURL=disclosureInitializer-CWxY7yo2.js.map
